"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var defaults = {
  ssn: {
    delimiter: '-',
    grouping: [3, 2, 4]
  },
  phone: {
    delimiter: '-',
    grouping: [3, 3, 4]
  },
  dateMMYY: {
    delimiter: '/',
    grouping: [2, 2]
  },
  dateMMYYYY: {
    delimiter: '/',
    grouping: [2, 4]
  },
  dateMDY: {
    delimiter: '/',
    grouping: [2, 2, 4]
  },
  card: {
    delimiter: ' ',
    grouping: [4, 4, 4, 4]
  },
  numeric: {
    filter: '(\\d*)'
  },
  currency: {
    symbol: '',
    delimiter: ',',
    grouping: [3, 3, 3, 3],
    decimalPoint: '.',
    decimals: [2],
    isCurrency: true
  },
  zip: {
    delimiter: '-',
    grouping: [5, 4]
  }
};

var filters = function filters(_ref) {
  var delimiter = _ref.delimiter,
      isCurrency = _ref.isCurrency,
      symbol = _ref.symbol,
      decimalPoint = _ref.decimalPoint,
      decimals = _ref.decimals;
  var leading = symbol ? "(\\".concat(symbol, ")?") : '';
  var tailing = decimals ? "(\\".concat(decimalPoint, "\\d{0,").concat(decimals, "})?") : '';
  var separator = delimiter ? "\\".concat(delimiter, "?") : '';

  var group = function group(val) {
    return isCurrency ? "(\\d{".concat(val, "})?") : "(\\d{0,".concat(val, "})?");
  };

  var first = function first(val) {
    return isCurrency ? "([0]|[1-9]".concat(val > 1 ? "\\d{0,".concat(val - 1, "}") : '', ")?") : group(val);
  };

  return function (val, ind, arr) {
    switch (true) {
      case arr.length === 1:
        return "".concat(leading).concat(first(val)).concat(tailing);

      case ind + 1 === 1:
        return "".concat(leading).concat(first(val));

      case ind + 1 === arr.length:
        return "".concat(separator).concat(group(val)).concat(tailing);

      default:
        return "".concat(separator).concat(group(val));
    }
  };
};

var values = function values(_ref2) {
  var symbol = _ref2.symbol,
      delimiter = _ref2.delimiter,
      decimals = _ref2.decimals;

  var group = function group(val, ind) {
    return symbol && ind === 1 ? "".concat(val) : "".concat(delimiter).concat(val);
  };

  var last = function last(val) {
    return decimals ? val : "".concat(delimiter).concat(val);
  };

  return function (val, ind, arr) {
    switch (ind + 1) {
      case 1:
        return val || '';

      case arr.length:
        return val && (last(val) || '');

      default:
        return val && (!arr[ind - 1] ? val : group(val, ind) || '');
    }
  };
};

var pattern = function pattern(_ref3) {
  var filter = _ref3.filter,
      grouping = _ref3.grouping,
      delimiter = _ref3.delimiter,
      isCurrency = _ref3.isCurrency,
      symbol = _ref3.symbol,
      decimalPoint = _ref3.decimalPoint,
      decimals = _ref3.decimals;
  return filter || grouping.map(filters({
    delimiter: delimiter,
    isCurrency: isCurrency,
    symbol: symbol,
    decimalPoint: decimalPoint,
    decimals: decimals
  })).join('');
};

var FormattedString = /*#__PURE__*/function () {
  function FormattedString() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, FormattedString);

    this.raw = value;
  }

  _createClass(FormattedString, [{
    key: "config",
    value: function config(_ref4) {
      var filter = _ref4.filter,
          grouping = _ref4.grouping,
          _ref4$delimiter = _ref4.delimiter,
          delimiter = _ref4$delimiter === void 0 ? '' : _ref4$delimiter,
          _ref4$isCurrency = _ref4.isCurrency,
          isCurrency = _ref4$isCurrency === void 0 ? false : _ref4$isCurrency,
          symbol = _ref4.symbol,
          decimalPoint = _ref4.decimalPoint,
          decimals = _ref4.decimals;

      /* arbitrary regex */
      this.filter = filter;

      if (isCurrency) {
        /* settings for currency formats */
        this.isCurrency = isCurrency;
        this.symbol = symbol || defaults.currency.symbol;
        this.grouping = grouping || defaults.currency.grouping;
        this.delimiter = delimiter || defaults.currency.delimiter;
        this.decimalPoint = decimalPoint || defaults.currency.decimalPoint;
        this.decimals = decimals || defaults.currency.decimals;
      } else {
        /* settings for common formats */
        this.delimiter = delimiter;
        this.grouping = grouping || [this.raw.length];
      }

      return this;
    }
  }, {
    key: "format",
    value: function format() {
      var str = this.isCurrency ? this.raw.split("".concat(this.delimiter)).join('') : this.raw;
      var re = new RegExp("^\\s*".concat(pattern(this), "\\s*$"));
      var parsed = str.match(re);
      return parsed && parsed.filter(function (val, ind) {
        return ind > 0;
      }).map(values(this)).join('') || '';
    }
  }, {
    key: "value",
    get: function get() {
      return this.format();
    }
  }, {
    key: "ssn",
    get: function get() {
      return this.config(defaults.ssn).value;
    }
  }, {
    key: "phone",
    get: function get() {
      return this.config(defaults.phone).value;
    }
  }, {
    key: "dateMMYY",
    get: function get() {
      return this.config(defaults.dateMMYY).value;
    }
  }, {
    key: "dateMMYYYY",
    get: function get() {
      return this.config(defaults.dateMMYYYY).value;
    }
  }, {
    key: "dateMDY",
    get: function get() {
      return this.config(defaults.dateMDY).value;
    }
  }, {
    key: "currency",
    get: function get() {
      return this.config(defaults.currency).value;
    }
  }, {
    key: "card",
    get: function get() {
      return this.config(defaults.card).value;
    }
  }, {
    key: "zip",
    get: function get() {
      return this.config(defaults.zip).value;
    }
  }]);

  return FormattedString;
}();

var autoFormatter = function autoFormatter(str) {
  return new FormattedString(str.valueOf());
};

var _default = autoFormatter;
exports.default = _default;